import { render, staticRenderFns } from "./OTagInput.vue?vue&type=template&id=3266c3d3&scoped=true&"
import script from "./OTagInput.vue?vue&type=script&lang=js&"
export * from "./OTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3266c3d3",
  null
  
)

export default component.exports